import { COLOR_PRIMARY } from "#constants/Styles"
import { Box, Paper, Stack, Typography } from "@mui/material"
import { useMemo } from "react"
import AssessmentIcon from "@mui/icons-material/Assessment"

/**
 *
 * @param {*} param0
 * @param {string} param0.selected
 * @param {array} param0.questionsData
 * @param {Object} param0.answer
 * @returns
 */
export const EvaluationQuestionsHeader = ({ answer }) => {
	const averageRating = useMemo(() => {
		let questionCount = 0
		let sum = 0
		Object.values(answer).forEach((question) => {
			const copy = { ...question }
			if ("observation" in copy) {
				delete copy.observation
			}
			if ("name" in copy) {
				delete copy.name
			}
			sum += Object.values(copy).reduce((acc, q) => {
				if (q) questionCount++
				return acc + q
			}, 0)
		})
		if (sum === 0) return 0
		return (sum / questionCount || 1).toFixed(2)
	}, [answer])

	return (
		<Stack
			spacing={3}
			mb={2}
			alignItems="center"
			justifyContent="center"
			direction={"row"}
		>
			<TableScore />

			<CardScore label="Calificación Promedio Total" value={averageRating} full />
		</Stack>
	)
}

const CardScore = ({ label, value, full = false }) => {
	return (
		<Paper
			elevation={1}
			sx={{
				p: 3,
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				gap: 1,
				borderRadius: 2,
				background: COLOR_PRIMARY,
				color: "white",
				width: full ? "30%" : "auto",
				minHeight: "100%",
			}}
		>
			<Typography variant="h2" sx={{ fontWeight: 700, lineHeight: 1 }}>
				{value}
			</Typography>
			<Typography variant="body2" sx={{ opacity: 0.9, textAlign: "center" }}>
				{label}
			</Typography>
		</Paper>
	)
}

const TableScore = () => {
	const Items = [
		{
			label:
				"Dominio sobresaliente. Ejemplos sólidos, relevantes y repetibles en otros contextos",
			value: "5",
		},
		{
			label:
				"Evidencia sólida de la competencia. Respuestas claras, estructuradas y coherentes",
			value: "4",
		},
		{
			label: "Demuestra la competencia de manera aceptable, pero con margen de mejora",
			value: "3",
		},
		{
			label: "Muestra la competencia de forma muy limitada o inconsistente",
			value: "2",
		},
		{
			label: "No demuestra la competencia. Respuestas vagas, sin ejemplos claros",
			value: "1",
		},
	]

	return (
		<Paper elevation={1} sx={{ width: "70%", borderRadius: 2 }}>
			<Box sx={{ background: COLOR_PRIMARY, p: 0.5, color: "white" }}>
				<Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
					Escala de Calificación
				</Typography>
			</Box>
			<Box>
				{Items.map((item, index) => (
					<Box
						key={index}
						sx={{
							display: "flex",
							alignItems: "center",
							p: 0.5,
							borderBottom: index < Items.length - 1 ? "1px solid" : "none",
							borderColor: "divider",
						}}
					>
						<Box
							sx={{
								minWidth: 20,
								height: 20,
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								borderRadius: 1,
								bgcolor: COLOR_PRIMARY,
								color: "white",
								fontWeight: 700,
								mr: 2,
							}}
						>
							{item.value}
						</Box>
						<Typography variant="body2">{item.label}</Typography>
					</Box>
				))}
			</Box>
		</Paper>
	)
}
